import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { AppConfig, ConfigDetails, ConfigDetailsWithKey } from '../../models/app-config.model';
import { delayedRetryHttp } from './delayed-retry';
import { UtilityService } from './utility.service';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {

    private baseUrl: string = '';
    private api: string = "api/BCMAppConfig";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService
    ) {
        this.baseUrl = _baseUrl + this.api;
    }
    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('App Config Service Client Side Error: ', errorResponse.error.message);
        } else {
            console.error('App Config Service Server Side Error: ', errorResponse);
        }

        return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
    }

    bCMGetConfigKeyValue(encryptedUser: any, configValue: string): Observable<ConfigDetails | void> {
        if (encryptedUser == null || encryptedUser == undefined || encryptedUser == '') {
            encryptedUser = localStorage.getItem('token');

            if (encryptedUser == null || encryptedUser == undefined || encryptedUser == '') {
                return;
            }
        }
        return this.httpClient
            .get<ConfigDetails>(`${this.baseUrl}/BCMGetConfigKeyValue/${configValue}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(
                catchError(this.handleErrors)
            );
    }

    mySO_Site_URL(): Observable<ConfigDetails | void> {
        return this.httpClient
            .get<ConfigDetails>(`${this.baseUrl}/MySO_Site_URL`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic '
                })
            }).pipe(
                catchError(this.handleErrors)
            );
    }

    async getIsNewSO(): Promise<ConfigDetails | void> {
        const a = await this.httpClient
            .get<ConfigDetails>(`${this.baseUrl}/GetIsNewSO`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic '
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", "", "AppConfigService", "getIsNewSO"); });
        return a;
    }
    async getAppConfigValue(encryptedUser: string, configValue: string): Promise<ConfigDetails | void> {
        if (encryptedUser == null || encryptedUser == undefined || encryptedUser == '') {
            encryptedUser = localStorage.getItem('token');

            if (encryptedUser == null || encryptedUser == undefined || encryptedUser == '') {
                return;
            }
        }
        const a = await this.httpClient
            .get<ConfigDetails>(`${this.baseUrl}/GetConfigKeyValue/${configValue}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "AppconfigService", "getAppConfigValue"); });
        return a;
    }

    async getAppConfigValues(encryptedUser: string, configValues: string[]): Promise<ConfigDetailsWithKey[] | void> {
        if (encryptedUser == null || encryptedUser == undefined || encryptedUser == '') {
            encryptedUser = localStorage.getItem('token');

            if (encryptedUser == null || encryptedUser == undefined || encryptedUser == '') {
                return;
            }
        }
        const a = await this.httpClient
            .post<ConfigDetailsWithKey[]>(`${this.baseUrl}/GetConfigKeyValues/`, configValues, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, configValues, "r - " + encryptedUser, encryptedUser, "AppconfigService", "getAppConfigValues"); });
        return a;
    }

}
